module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=CM - Cameroon.7750f82e.svg";